import { useNavigate } from "react-router-dom"
import styles from "./styles.module.scss"
import { ReactComponent as BackIcon } from "assets/icons/back.svg"
import CircleButton from "@atoms/icon-button"
import { Breadcrumb } from "antd"

export interface IPageHeader {
  title?: React.ReactNode
  subTitle?: React.ReactNode
  onButtonClick?: () => void
  rightContent?: React.ReactNode
  breadcrumbs?: { title?: string; link?: string }[]
  hasBackButton?: boolean
}

const PageHeader: React.FC<IPageHeader> = ({
  title,
  subTitle,
  onButtonClick,
  rightContent,
  breadcrumbs,
  hasBackButton = true,
}) => {
  const navigate = useNavigate()
  return (
    <>
      <Breadcrumb
        style={{ padding: 20 }}
        items={breadcrumbs?.map((item, index) => ({
          key: index,
          title: item.title,
          onClick: () => item.link && navigate(item.link),
        }))}
      />
      <div className={styles.head}>
        <div className={styles.leftContent}>
          {hasBackButton && (
            <CircleButton
              className={styles.backButton}
              icon={<BackIcon />}
              size="large"
              type="dashed"
              onClick={onButtonClick ? onButtonClick : () => navigate(-1)}
            />
          )}
          <div className={styles.titleContainer}>
            {title}
            {subTitle}
          </div>
        </div>
        <div>{rightContent}</div>
      </div>
    </>
  )
}

export default PageHeader
